
import { Component, ActionButtonConfig, FormModalMixins, Watch } from "@/lib";
import FactoryEntity from "@/store/modules/shipment/factorycost/factoryentity";

@Component({name:"edit-security-item-modal"})
export default class EditSecurityItemModal extends FormModalMixins {
  model = new FactoryEntity();

  

 get record() {
    return this.$store.state.shipment.factorycost.securityItem;
  }
 get factoryList() {
  
    return  this.$store.state.system.factory.factoryList;
  }
  async created(){
            
         await this.$store.dispatch("system/factory/getFactoryList");
        }

  resetModel(){
    this.model = new FactoryEntity();
  }

  cancel(){
    this.$emit("cancel");
  }

 close() {
  this.config.isShow = false;
  this.model = new FactoryEntity();
  }
}
